import { createGetEndpoint } from '@sonar-software/sonar-http';
import { ShardSearchEntryDetails } from '../@types';

export type GetDefaultShardCatalogDetailsResponse = ShardSearchEntryDetails;

export const getDefaultShardCatalogDetails = createGetEndpoint<void, GetDefaultShardCatalogDetailsResponse>(
	'/api/v3/core/search/shard-catalog-details/default',
	{
		skipAuthRefresh: true
	}
);
